import { AreaNotesState } from "./types";

export function getDefaultState(): AreaNotesState {
	return {
		areaNotes: [],
		areaNotesLength: 0,
		areaNoteToEdit: null,
		currentGroupId: null,
		currentGroupTitle: "",
		isFormShown: false,
		isEditing: false
	}
}